module.exports = __webpack_public_path__ + "img/normal-login.74e4a23e.png";